import { Typography } from "antd";
import { useState } from "react";
import { getIcon } from "../utils/icons";
import TrustCenterCard from "./TrustCenterCard";

const { Title, Paragraph, Text } = Typography;

export default function ComplianceProgramCard({
  program,
  fixedHeight = false,
}) {
  // const textRef = useRef < HTMLDivElement > null;

  // useEffect(() => {
  //   const checkTruncation = () => {
  //     const element = textRef?.current?.querySelector(".ant-typography");
  //     if (textRef.current && element) {
  //       setIsTruncated(element.scrollHeight > element.clientHeight);
  //     }
  //   };

  //   checkTruncation();
  //   window.addEventListener("resize", checkTruncation);
  //   return () => window.removeEventListener("resize", checkTruncation);
  // }, [program.description]);

  const textContent = (
    <Paragraph
      ellipsis={{
        rows: 3,
        tooltip: false,
      }}
      style={{
        color: "#666",
        fontSize: "14px",
        marginBottom: "16px",
        lineHeight: "1.5",
      }}
    >
      {program.description}
    </Paragraph>
  );
  return (
    <TrustCenterCard>
      <div
        style={{
          width: "64px",
          height: "64px",
          border: "1px solid #000",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "12px",
          flexShrink: 0, // Prevent shrinking
        }}
      >
        {getIcon(program.icon)}
      </div>
      <Title
        level={4}
        style={{
          marginBottom: "8px",
          marginTop: "0px",
          flexShrink: 0, // Prevent shrinking
        }}
      >
        {program.title}
      </Title>
      <div style={{ flex: 1, overflow: "hidden" }}>
        {/* {isTruncated ? (
          <Tooltip title={program.description} placement="bottom">
            {textContent}
          </Tooltip>
        ) : (
          textContent
        )} */}
        {textContent}
      </div>
      <Text
        style={{
          fontSize: "12px",
          color: "#999",
          marginTop: "auto",
          flexShrink: 0, // Prevent shrinking
        }}
      >
        {program.lastAudit}
      </Text>
    </TrustCenterCard>
  );
}
